import { render, staticRenderFns } from "./houseType.vue?vue&type=template&id=19839130&"
import script from "./houseType.vue?vue&type=script&lang=js&"
export * from "./houseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports